import { parsePhoneNumberFromString } from 'libphonenumber-js'

const isValidPhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) return false

  try {
    const normalized = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`
    const parsed = parsePhoneNumberFromString(normalized)
    return parsed?.isValid() ?? false
  } catch {
    return false
  }
}

export default isValidPhoneNumber
